import cx from 'classnames';
import { extendTailwindMerge } from 'tailwind-merge';

type TypographyGroups = 'body' | 'heading';

const twMerge = extendTailwindMerge<TypographyGroups>({
  extend: {
    classGroups: {
      body: ['body-1', 'body-2', 'body-3', 'body-4', 'body-5', 'body-6', 'body-7', 'heading-1', 'heading-2', 'heading-3', 'heading-4'],
    },
  },
});

export const cn = (...args: cx.ArgumentArray) => {
  return twMerge(cx(...args));
};
